import { Button } from '@ais-ui/ui-core';
import { cn } from '@ais-ui/utils';
import { SettingItem } from './SettingsPage';
import { NavLink } from 'react-router-dom';

interface SidebarNavProps extends React.HTMLAttributes<HTMLElement> {
  items: {
    id: SettingItem;
    title: string;
    onClick: () => void;
  }[];
  activeItem: SettingItem;
}

export function SidebarNav({
  className,
  items,
  activeItem,
  ...props
}: SidebarNavProps) {
  return (
    <nav
      className={cn(
        'flex space-x-2 lg:flex-col lg:space-x-0 lg:space-y-1',
        className
      )}
      {...props}
    >
      {items.map((item) => {
        const isActive = activeItem === item.id;
        return (
          <Button
            id={item.id}
            key={item.id}
            variant="ghost"
            className={cn(
              'w-56 justify-start relative transition-all duration-150',
              'hover:bg-primary/5',
              isActive && 'bg-primary/10 hover:bg-primary/10 font-medium'
            )}
            onClick={() => item.onClick()}
          >
            {isActive && (
              <span className="absolute left-0 top-0 bottom-0 w-0.5 bg-primary rounded-full" />
            )}
            {item.title}
          </Button>
        );
      })}
    </nav>
  );
}
